import * as Yup from 'yup';

export const RecordSchema = Yup.object()
                               .shape({
                                          productCode: Yup.string()
                                                          .required('Required'),
                                      });
